import React from 'react';
import PropTypes from 'prop-types';
import style from './JobCard.module.sass';

const JobCard = ({
  job, isDragging, onOpenDetail, showPhotographers,
}) => {
  const photographers = job.photographers || [];
  const handleMenuClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (onOpenDetail) {
      onOpenDetail(job);
    }
  };

  return (
    <div className={`${style.jobCard} ${isDragging ? style.dragging : ''}`}>
      <div className={style.cardHeader}>
        <div className={`${style.schoolName} ${job.has_changes ? style.changed : ''}`}>
          {job.school_name}
        </div>
        <button
          type="button"
          className={style.menuButton}
          onClick={handleMenuClick}
          onMouseDown={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
          title="View details"
        >
          &#8942;
        </button>
      </div>
      <div className={style.trigs}>
        {job.trigs || 0}
        {' '}
        trigs ·
        {' '}
        {job.job || '-'}
      </div>
      {showPhotographers && (
        <div className={style.photographers}>
          {photographers.length > 0 ? (
            photographers.map((p) => (
              <div
                key={p.id}
                className={style.photographerRow}
                title={[p.rig, p.name].filter(Boolean).join(' ')}
              >
                <span className={style.rigName}>{p.rig}</span>
                {p.name}
              </div>
            ))
          ) : (
            <span className={style.noPhotographer}>No photographer assigned</span>
          )}
        </div>
      )}
    </div>
  );
};

JobCard.propTypes = {
  job: PropTypes.shape({
    school_name: PropTypes.string,
    has_changes: PropTypes.bool,
    photographers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      rig: PropTypes.string,
      name: PropTypes.string,
    })),
    trigs: PropTypes.number,
    job: PropTypes.string,
  }).isRequired,
  isDragging: PropTypes.bool.isRequired,
  onOpenDetail: PropTypes.func.isRequired,
  showPhotographers: PropTypes.bool.isRequired,
};

export default JobCard;
